export const printStatus = {
  production: 'Production',
  delivery: 'Delivery',
}
